import { render, staticRenderFns } from "./CreateBankAccount.vue?vue&type=template&id=6a63c132&scoped=true&"
import script from "./CreateBankAccount.vue?vue&type=script&lang=js&"
export * from "./CreateBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreateBankAccount.vue?vue&type=style&index=0&id=6a63c132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a63c132",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCol,VContainer,VRow,VTab,VTabItem,VTabs,VTabsItems,VToolbar})
